
const { isEmpty } = require('lodash');
const LatLng = require('../../olycommon/geolocation/latlng');
const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class FulfilmentSelectorPickupAddressController {
    constructor($q, $timeout, settings, analyticsService, locationService, pickupAddressSearchService, fulfilmentSelectorService, moveFocus) {
        this.$q = $q;
        this.$timeout = $timeout;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.locationService = locationService;
        this.pickupAddressSearchService = pickupAddressSearchService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.pickupStores = [];
        this.locationSearchText = this.settings.fulfilmentSelector.searchByCurrentLocationLabel;

        this.currentLocation = this.locationService.latlng;
        this.isGeolocationEnabled = !isEmpty(this.locationService.latlng);

        this.locationService.getCurrentLocation().then((location) => {
            this.currentLocation = location;
            this.isGeolocationEnabled = !!location;
        }, () => {
            this.currentLocation = null;
            this.isGeolocationEnabled = false;
        });

        this.storesPerPage = this.settings.fulfilmentSelector.pickupStoresPerPage;
        this.numberOfStoresToShow = this.storesPerPage;

        this.selectedStoreText = this.selectedAddress ? this.selectedAddress.AddressText : '';
        this.screenName = 'FulfilmentSelection';
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Fulfilment type toggle')
            .withValue('Pickup')
            .withEventName('modal_view')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withTrackingType('link')
            .build();

        this.analyticsService.push(event);

        this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
    }

    onSuburbSelected(suburb) {
        if (!isEmpty(suburb)) {
            if (!suburb.AddressText) {
                this.suburbs = [];
                const element = document.getElementById(`suburb-${this.inputId}`);
                element.value = suburb.PostCode;
                this.$timeout(() => {
                    if (typeof (Event) === 'function') {
                        element.dispatchEvent(new Event('change'));
                    } else {
                        const event = document.createEvent('Event');
                        event.initEvent('change', false, true);
                        element.dispatchEvent(event);
                    }
                }, 50);
            } else {
                this.onSelectStore(suburb);
            }
        }
    }

    onClickGeo($event) {
        $event.preventDefault();
        this.moveFocus(`#suburb-${this.inputId}`);
        if (this.suburbText) {
            return;
        }
        if (this.isGeolocationEnabled) {
            const element = document.getElementById(`suburb-${this.inputId}`);
            element.value = this.locationSearchText;
            this.$timeout(() => {
                element.dispatchEvent(new Event('change'));
            }, 50);
        }

    }

    suburbOnType() {
        if (!!this.suburbText && this.suburbText.length >= this.settings.fulfilmentSelector.numberOfKeystrokesToTriggerSearch) {
            return this.performSearch(this.suburbText).then(response => (response ? this.suburbs : this.pickupStores));
        }

        this.selectedAddress = null;

        return this.$q.defer().promise;
    }

    performSearch(searchTerm) {
        if (searchTerm === this.locationSearchText && this.isGeolocationEnabled) {
            searchTerm = this.currentLocation;
        }

        if (searchTerm instanceof LatLng) {
            return this.searchStoresByGeolocation(searchTerm);
        }

        if (isNaN(searchTerm)) {
            return this.searchSuburbs(searchTerm);
        }

        return this.searchStoresByPostcode(searchTerm);
    }

    searchSuburbs(searchTerm) {
        this.searchMode = this.pickupAddressSearchService.searchModes.suburbs;
        return this.pickupAddressSearchService.searchSuburbs(searchTerm).then((suburbs) => {
            this.suburbs = suburbs;
            return true;
        });
    }

    searchStoresByPostcode(postcode) {
        this.searchMode = this.pickupAddressSearchService.searchModes.stores;
        return this.pickupAddressSearchService.searchByPostcode({ postcode })
            .then((pickupStores) => {
                this.setStores(pickupStores);
                this.suburbs = [];
                return false;
            });
    }

    searchStoresByGeolocation(position) {
        this.searchMode = this.pickupAddressSearchService.searchModes.stores;
        return this.pickupAddressSearchService.searchByGeolocation(position)
            .then((pickupStores) => {
                this.setStores(pickupStores);
                this.suburbs = [];
                return false;
            });
    }

    setStores(stores) {
        this.pickupStores = stores;
        this.selectedStore = null;
        this.selectedStoreText = null;
    }

    getSuburbText(item) {
        return item.SuburbStateString ? item.SuburbStateString : item.AddressText;
    }

    clearSearch(input) {
        if (input) {
            this.suburbText = null;
            this.selectedSuburb = null;
        }
        if (!input) {
            this.selectedStoreText = null;
            this.selectedStore = null;
            this.selectedAddress = null;
        }
        this.moveFocus(`#suburb-${this.inputId}`);
    }

    onSelectStore(store) {
        if (this.selectedAddress && this.selectedAddress.AddressId !== store.AddressId) {
            const event = new TealiumEventBuilder()
                .withScreenName(this.screenName)
                .withLabel('Pickup store change')
                .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
                .withEventName('modal_interaction')
                .withTrackingType('link')
                .build();

            this.analyticsService.push(event);
        }
        this.selectedStore = store.AddressId;
        this.selectedStoreText = store.AddressText;
        this.suburbText = null;
        this.selectedSuburb = null;
        this.pickupStores = [];
        this.setPickupAddress({ addr: store });
        this.moveFocus('.fulfilmentSelectorDialog-button');
    }

    $onDestroy() {
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }

    onSelectedFocus($event) {
        const element = $event.currentTarget;
        if (element.selectionStart === 0 && element.selectionEnd === element.value.length) {
            this.$timeout(() => {
                element.setSelectionRange(0, element.value.length);
            }, 1);
        } else {
            element.setSelectionRange(0, element.value.length);
        }
    }

    onSelectedKeypress($event) {
        const inp = String.fromCharCode($event.keyCode);
        if ($event.keyCode === 37 || $event.keyCode === 38 || $event.keyCode === 39 || $event.keyCode === 40 || $event.keyCode === 36 || $event.keyCode === 35) {
            // Arrow keys + page up/down
            this.onSelectedFocus($event);
        } else if ($event.keyCode === 27 || $event.keyCode === 8 || $event.keyCode === 46 || $event.keyCode === 9) {
            // Allow esc/bck/del/Tab keys
        } else if ($event.keyCode === 32) {
            // space
            $event.stopPropagation();
            this.moveFocus(`#suburb-${this.inputId}`);
        } else if (/[a-zA-Z0-9-_ ]/.test(inp)) {
            // All other keys should do nothing
            const element = $event.currentTarget;
            element.value = '';
            this.suburbText = String.fromCharCode($event.keyCode);
            this.$timeout(() => {
                element.dispatchEvent(new Event('change'));
                this.moveFocus(`#suburb-${this.inputId}`);
            }, 50);
            $event.stopPropagation();
            $event.preventDefault();
        } else {
            // All other keys should do nothing
            $event.preventDefault();
        }
    }
}

FulfilmentSelectorPickupAddressController.$inject = ['$q', '$timeout', 'Settings', 'AnalyticsService', 'LocationService', 'PickupAddressSearchService', 'FulfilmentSelectorService', 'MoveFocus'];

const fulfilmentSelectorPickupAddressComponentDefinition = {
    bindings: {
        inputId: '@',
        classModifier: '@?',
        setPickupAddress: '&',
        selectedAddress: '=?',
        mandatoryError: '<?',
    },
    controller: FulfilmentSelectorPickupAddressController,
    template: require('./fulfilment-selector-pickup-address.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorPickupAddressController,
    fulfilmentSelectorPickupAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-pickup-address.component.js